import { useEffect, useState } from 'react';
import Slider from './components/slider/slider';

// Main
function App() {

  const churnMultiplier = 0.5
  const churnRevenue = 0.02
  const churnReduction = 0.05


  const [noOfEmployees, setNoOfEmployees] = useState(30000)
  const [averageSalary, setAverageSalary] = useState(30000)
  const [churnRate, setChurnRate] = useState(10)
  const [annualRevenue, setAnnualRevenue] = useState(30000000)
  

  const [result, setResult] = useState()

  useEffect(
    () => {
      const churnCost = (noOfEmployees * churnRate/100) * averageSalary * churnMultiplier + (annualRevenue * churnRevenue);
      const totalSavings = churnCost * churnReduction;
      const totalSavingsY1 = Math.floor(totalSavings);
      const totalSavingsY2 = Math.floor(totalSavings * 1.1);
      const totalSavingsY3 = Math.floor(totalSavingsY2 * 1.1);

      setResult({
        totalSavingsY1, totalSavingsY2, totalSavingsY3
      })
    }, 
    [noOfEmployees, averageSalary, churnRate, annualRevenue]
  )

  return (
    <div className="app">
      {result && (<div className='grid grid-col-2'>
        <div className='grid gap-75'>
          <Slider label={"No. of Employees"} min={1000} max={150000} value={noOfEmployees} setValue={setNoOfEmployees}  />
          <Slider label={"Average salary ($)"} min={0} max={150000} value={averageSalary} setValue={setAverageSalary} prefixValueUnit={"$"} />
          <Slider label={"Average churn rate (%)"} min={0} max={45} value={churnRate} setValue={setChurnRate}  sufixValueUnit={"%"} />
          <Slider label={"Annual Revenue ($m)"} min={0} max={100000000} value={annualRevenue} setValue={setAnnualRevenue}  prefixValueUnit={"$"} />
        </div>

        <div className='result-cont'>
          <div>
            <p className='result-title'>Year 1 Saving</p>
            <h3 className='result'>${result.totalSavingsY1.toLocaleString()}</h3>
          </div>
          <div>
            <p className='result-title'>Year 2 Saving</p>
            <h3 className='result'>${result.totalSavingsY2.toLocaleString()}</h3>
          </div>
          <div>
            <p className='result-title'>Year 3 Saving</p>
            <h3 className='result'>${result.totalSavingsY3.toLocaleString()}</h3>
          </div>
        </div>
      </div>)}
      
    </div>
  );
}

export default App;
